import { Shadow, Text, HStack, VStack } from '@genial/components';
import { Box } from 'native-base';
import React from 'react';

import { RecommendedPortfolioBadge } from '../../../../../../../components/RecommendedPortfolioBadge';
import { StrategyAssetsQueryItem } from '../../../../../../../store/customerAssetDetail/types';
import { IDynamicProductSearchItem } from '../../../_dynamic';
import { ProfitabilityText } from '../ProfitabilityText';

export const ProductItemTablet: React.FC<IDynamicProductSearchItem<StrategyAssetsQueryItem>> = ({
  item,
}) => {
  const fields = [
    {
      label: 'Tipo',
      value: <Text>{item.typeNameNormalized}</Text>,
    },
    {
      label: 'Valor Bruto',
      value: <Text>{item.grossValueNormalized}</Text>,
    },
    {
      label: 'Valor Líquido',
      value: <Text>{item.netValueNormalized}</Text>,
    },
    {
      label: 'Rendimento',
      value: <Text>{item.incomeNormalized}</Text>,
    },
    {
      label: 'Rentabilidade',
      value: <ProfitabilityText profitability={item.profitability} />,
    },
  ];

  const labelsWithValues = fields.map((label) => {
    return (
      <VStack space="stack.quarck" key={label.label} flex={1}>
        <Text variant="bold">{label.label}</Text>
        <Text>{label.value}</Text>
      </VStack>
    );
  });

  return (
    <Shadow level={1} borderRadius="xs" width="full" padding="inset.xs">
      <Box
        position="absolute"
        top={0}
        left={0}
        bottom={0}
        w="4px"
        backgroundColor={item.productColor}
        borderTopLeftRadius="full"
        borderBottomLeftRadius="full"
      />
      <VStack width="full" space="stack.xxxs">
        <HStack
          justifyContent="space-between"
          alignItems="center"
          width="full"
          borderBottomColor="neutral.light"
          borderBottomWidth={1}
          paddingBottom="inset.xs">
          <Text fontSize="md" variant="semibold" testId="product-item-tablet-name">
            {item.assetNameNormalized}
          </Text>
          <RecommendedPortfolioBadge
            hasRecommendedPortfolioLink={item.hasRecommendedPortfolioLink}
            recommendedPortfolioLinks={item.recommendedPortfolioLinks}
          />
        </HStack>
        <HStack width="full">{labelsWithValues}</HStack>
      </VStack>
    </Shadow>
  );
};
